<template>
  <div>
    <div class="zgornji-odmik">
      <div>
        <p class="navadno-besedilo odmik-nosilci">
          Stroškovni nosilci so ločevanje porabe med posameznimi enotami. Priporočamo podjetjem, ki imajo
          naročenih več telefonskih številk in želijo ločiti porabo na posamezne enote ali prostore, v
          katerih uporabljajo telefonske številke. Pregled porabe lahko spremljajo na zavihku
          <a href="/Poraba/PorabaTelefonija" class="primarna-barva">
            Poraba / Telefonija</a>.
        </p>
      </div>
      <div v-if="ustvarjeniStroskovniNosilci.length === 0" class="izgled-nosilec-se-ni-ustvarjen"
           v-loading="nalaganjeUstvarjenihStroskovnihNosilcev">
        <p class="navadno-besedilo">
          <b>
            <i class="fa fa-exclamation-triangle"></i>
            Niste še dodali nobenega stroškovnega nosilca.
          </b>
        </p>
      </div>
      <div class="seznam-stroskovnih-nosilcev" v-if="ustvarjeniStroskovniNosilci.length > 0">
        <el-table
          :data="seznamPodStroskovnihNosilcev"
          style="width: 100%"
          :expand-row-keys="expandRowKeys"
          :row-key="row => row.id_expense_account"
          @expand-change="Izbranavrstica"
          v-loading="nalaganjeUstvarjenihStroskovnihNosilcev">
          <el-table-column label="Naziv nosilca">
            <template slot-scope="scope">
              {{ scope.row.naziv }}
            </template>
          </el-table-column>
          <el-table-column label="Oznaka nosilca">
            <template slot-scope="scope">
              {{ scope.row.identiteta }}
            </template>
          </el-table-column>
          <el-table-column label="Telefonske številke">
            <template slot-scope="scope">
              <div v-if="scope.row.relations.length === 0">
                (brez)
              </div>
              <div v-else>
                {{ scope.row.relations.length }}
              </div>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="notranji-odmik">
                <div v-if="stevilkeDodaneVnosilec.length > 0"
                     v-loading="pridobivanjePodatkovStevilkeDodaneVnosilec"
                     style="padding-bottom: 30px">
                  <div>
                    <p class="open-sans-14pt">
                      <b>
                        Seznam telefonskih številk dodanih v stroškovni nosilec
                      </b>
                    </p>
                  </div>
                  <div style="padding-top: 10px">
                    <el-table :data="seznamPodRacunovTelStevilk"
                              class="velikost-tabele"
                              :expand-row-keys="expandRowMsisdnKeys"
                              :row-key="row => row.unicId"
                              @expand-change="IzbranavrsticaVnosilcu">
                      <el-table-column prop="msisdn"
                                       label="Številka">
                      </el-table-column>
                      <el-table-column prop="trajanje_od"
                                       label="Trajanje od">
                      </el-table-column>
                      <el-table-column label="Trajanje">
                        <template slot-scope="scope">
                          <div v-if="scope.row.trajanje_do === '01.01.2300'">
                            <span class="levi-neomejeno">
                              Neomejeno
                            </span>
                          </div>
                          <div v-else-if="typeof scope.row.trajanje_do !== 'undefined' &&
                                                        scope.row.trajanje_do !== '01.01.2300'">
                            {{ scope.row.trajanje_do }}
                          </div>
                          <div v-else>
                            <span class="levo-brez">
                              (brez)
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column align="right">

                        <div slot-scope="scope">
                          <a @click="BrisanjeStevilkeIzStroskovnegaNosilca
                                                               (scope.row.msisdn, scope.row.id_expense_account)"
                             style="cursor: pointer">
                            <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                          </a>
                        </div>
                      </el-table-column>
                      <el-table-column type="expand">
                        <template slot-scope="props">
                          <div v-if="niPodatkovOstevilki.length > 0"
                               v-loading="nalaganjePodatkovOstevilki"
                               class="postavitev-urejanje-datuma-seznam-telefonskih-stevilk">
                            <el-date-picker
                              class="input-datum mobilni-input"
                              v-model="posameznaStevilkaTrajanjeOd"
                              type="date"
                              :picker-options="pickerOptions"
                              format="dd.MM.yyyy HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="Izberite začetek">
                            </el-date-picker>
                            <el-date-picker
                              class="mobilni-input"
                              :disabled="onemogocenoSpreminjanjeDatuma"
                              v-model="posameznaStevilkaTrajanjeDo"
                              type="date"
                              format="dd.MM.yyyy HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="Izberite konec">
                            </el-date-picker>
                            <div class="label-button">
                              <el-button type="primary" class="gumb-potrdi shrani-gumb" style="margin-top: 4px;"
                                         @click="UrejanjeStevilkeNaStroskovnemNosilcu()">
                                SHRANITE
                              </el-button>
                              <br/>
                              <el-checkbox class="mobilni-pogled" v-model="urejanjePosamezneTelefonskeNeomejeno">
                                <span :class="urejanjePosamezneTelefonskeNeomejeno ? 'neomejeno krepko' : 'neomejeno'">
                                  Neomejeno
                                </span>
                              </el-checkbox>
                              <div class="odstrani-stevilko">
                                <a class="odstrani"
                                   @click="BrisanjeStevilkeIzStroskovnegaNosilca(props.row.msisdn, props.row.id_expense_account)"
                                   style="cursor: pointer">
                                  <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                                  <span class="krepko crna odmik-levo">
                                    ODSTRANI ŠTEVILKO
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="text-center" style="cursor: pointer;">
                    <br/>
                    <el-pagination
                      :hide-on-single-page="true"
                      :current-page="trenutnoIzbranaStranNosilci"
                      @current-change="PrikaziStranDodaneStevilkeVnosilec"
                      :page-size="4"
                      layout="prev, pager, next"
                      :total="dolzinaSeznamaNosilci"
                      small>
                    </el-pagination>
                  </div>
                </div>
                <div>
                  <p class="open-sans-14pt">
                    <b>
                      Dodajte telefonske številke na stroškovni nosilec
                    </b>
                  </p>
                </div>
                <div v-if="prosteTelefonskeStevilke.length > 0">
                  <div class="podatki">
                    <div class="min-sirina">
                      <p>
                        Izberite telefonsko številko
                      </p>
                      <el-select class="width-proste-telefonske-stevilke"
                        v-model="dodajanjeStevilk"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="Izberi">
                        <el-option v-for="telefonske in prosteTelefonskeStevilke"
                                   :key="telefonske.stevilka"
                                   :label="telefonske.stevilka"
                                   :value="telefonske.stevilka">
                        </el-option>
                      </el-select>
                      <div style="padding-top: 50px" class="gumb-dodaj">
                        <el-button class="gumb-potrdi"
                                   @click="DodajanjeStevilkeNaStroskovniNosilec
                                                           (props.row.id_expense_account)">
                          DODAJTE ŠTEVILKE
                        </el-button>
                      </div>
                    </div>
                    <div class="min-sirina">
                      <div>
                        <p>
                          Izberite trajanje
                        </p>
                        <div>
                          <el-date-picker
                            v-model="spremembaTrajanjaOdPosameznaStevilka"
                            type="date"
                            :picker-options="pickerOptions"
                            format="dd.MM.yyyy HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="Izberite začetek">
                          </el-date-picker>
                        </div>
                        <div style="padding-top: 10px">
                          <el-date-picker
                            :disabled="onemogocenoSpreminjanjeDodajanjeDatuma"
                            v-model="spremembaTrajanjaDoPosameznaStevilka"
                            type="date"
                            format="dd.MM.yyyy HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="Izberite konec">
                          </el-date-picker>
                        </div>
                      </div>
                      <div style="padding-top: 10px">
                        <el-checkbox v-model="dodajanjeInUrejanjeTelefonskeStevilke">
                          <span :class="dodajanjeInUrejanjeTelefonskeStevilke ? 'krepko': ''">Neomejeno</span>
                        </el-checkbox>
                      </div>
                    </div>
                    <div class="stevilka-nosilec">
                      <a class="odstrani"
                         @click="OdstranitevStroskovnegaNosilca(props.row.id_expense_account, props.row.naziv)"
                         style="cursor: pointer">
                        <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                        <span class="krepko crna odmik-levo">
                        ODSTRANI NOSILEC
                      </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div v-if="prosteTelefonskeStevilke.length <= 0">
                  <div class="podatki">
                    <div class="min-sirina">
                      <el-row :gutter="20">
                        <el-col :span="14">
                          <div class="grid-content">
                            <el-button :disabled="disabledGumb" class="gumb-ni-na-voljo">
                              DODAJTE ŠTEVILKE
                            </el-button>
                          </div>
                        </el-col>
                        <el-col :span="10">
                          <div class="grid-content">
                            <span style="padding-left: 13px; color: #080809;">
                              <el-icon class="el-icon-info" style="font-size: 16px">
                              </el-icon>
                              <span style="padding-left: 8px" class="navadno-besedilo">
                                Žal nimate nobene številke na voljo. Prosimo, izbrišite ali uredite
                                najprej telefonske številke v obstoječih nosilcih.
                              </span>
                            </span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="stevilka-nosilec">
                      <a class="odstrani"
                         @click="OdstranitevStroskovnegaNosilca(props.row.id_expense_account, props.row.naziv)"
                         style="cursor: pointer">
                        <img src="/static/img/Naroci/Icon-awesome-trash-alt.svg">
                        <span class="krepko crna odmik-levo">
                        ODSTRANI NOSILEC
                      </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <br style="clear: both"/>
        <div class="text-center">
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStranUstvarjenihStroskovnihNosilcev"
            :current-page="trenutnoIzbranaStranStroskovniNosilci"
            :page-size="4"
            layout="prev, pager, next"
            :total="dolzinaSeznamaStroskovnihNosilcev"
            small>
          </el-pagination>
        </div>
      </div>
      <div v-if="ustvarjeniStroskovniNosilci.length > 0" style="padding-top: 30px;">
        <hr class="hr-stil">
        <div class="odmik-20">
          <p class="open-sans-20pt">
            Dodajanje stroškovnih nosilcev
          </p>
        </div>
      </div>
      <div class="odmik-20" v-loading="uspesnoDodanNosilec">
        <el-form>
          <div class="postavitev-ustvari-nov-nosilec">
            <el-form-item label="Naziv nosilca:" placeholder="Vnesite naziv nosilca">
              <el-input v-model="novNazivNosilca" class="naziv-nosilca-velikost">
              </el-input>
              <div class="opis-inputa naziv">
                <el-icon class="el-icon-info">
                </el-icon>
                <span style="padding-left: 8px">
                  V to polje lahko vpišete ime uporabnika telefonske številke.
                </span>
              </div>
            </el-form-item>
            <el-form-item label="Oznaka nosilca:" placeholder="Vnesite oznako nosilca">
              <el-input v-model="novaOznakaNosilca" class="oznaka-nosilca-input">
              </el-input>
              <div  class="opis-inputa oznaka">
                <el-icon class="el-icon-info">
                </el-icon>
                <span style="padding-left: 8px">
                    V to polje lahko npr vpišete naziv oddelka ali prostora, kjer uporabljajo
                    telefonsko številko.
                </span>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div style="clear: both"/>
        <div class="odmik-20">
          <el-button @click="DodajanjeNovegaStroskovnegaNosilca" class="gumb-potrdi mobile-button">
            DODAJTE NOSILEC
          </el-button>
        </div>
      </div>
    </div>
    <div class="hr-odmik">
      <hr class="hr-stil">
    </div>
    <div class="odmik-20">
      <p class="open-sans-20pt">
        Seznam telefonskih številk
        <span class="iskanje-input">
          <el-input v-model="isciPoPodatkih" class="iskanje-kontaktov-input"
                    placeholder="Išči.." prefix-icon="el-icon-search">
          </el-input>
        </span>
      </p>
        <el-table
          :data="seznamPodTelefonskihStevilk"
          style="width: 100%"
          :expand-row-keys="expandRowStevilkaKeys"
          :row-key="row => row.stevilka"
          @expand-change="SeznamTelefonskihStevilk"
          v-loading="nalaganjeTelefonskihStevilk">
          <el-table-column label="Naziv nosilca">
            <template slot-scope="scope">
              <div v-if="typeof scope.row.nosilecNaziv !== 'undefined'">
                {{ scope.row.nosilecNaziv }}
              </div>
              <div v-else>
                (brez)
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Telefonska številka">
            <template slot-scope="scope">
              <div class="stevilka">
                +{{ scope.row.stevilka }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Trajanje">
            <template slot-scope="scope">
              <div v-if="scope.row.trajanje_do === '01.01.2300'">
                Neomejeno
              </div>
              <div v-else-if="typeof scope.row.trajanje_do !== 'undefined' &&
                             scope.row.trajanje_do !== '01.01.2300'">
                {{ scope.row.trajanje_do }}
              </div>
              <div v-else>
                (brez)
              </div>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div v-if="niPodatkovOstevilki.length > 0" v-loading="nalaganjePodatkovOstevilki"
                   class="postavitev-urejanje-datuma-seznam-telefonskih-stevilk">
                <el-date-picker
                  class="odmik-picker"
                  v-model="posameznaStevilkaTrajanjeOd"
                  type="date"
                  :picker-options="pickerOptions"
                  format="dd.MM.yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Izberite začetek">
                </el-date-picker>
                <el-date-picker
                  class="odmik-picker"
                  :disabled="onemogocenoSpreminjanjeDatuma"
                  v-model="posameznaStevilkaTrajanjeDo"
                  type="date"
                  format="dd.MM.yyyy HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="Izberite konec">
                </el-date-picker>
                <el-button type="primary" class="gumb-potrdi"
                           @click="UrejanjeStevilkeNaStroskovnemNosilcu()">
                  SHRANITE
                </el-button>
                <br/>
                <el-checkbox v-model="urejanjePosamezneTelefonskeNeomejeno"
                             :class="urejanjePosamezneTelefonskeNeomejeno ? 'krepko neomejeno' : 'neomejeno'">
                  Neomejeno
                </el-checkbox>
              </div>
              <div v-else style="padding: 50px;" v-loading="nalaganjePodatkovOstevilki">
                <div class="postavitev-info-stroskovni" v-if="!nalaganjePodatkovOstevilki">
                  Telefonska številka še ni dodeljena v stroškovni nosilec. Za urejanje najprej ustvarite nov stroškovni nosilec.
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <br style="clear: both"/>
        <div class="text-center">
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStranSeznamTelefonskihStevilk"
            :current-page="trenutnoIzbranaStranSeznamTelefonskihStevilk"
            :page-size="8"
            layout="prev, pager, next"
            :total="dolzinaSeznamaTelefonskihStevilk"
            small>
          </el-pagination>
        </div>
      </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import {Button, Collapse, CollapseItem, Input, Loading, MessageBox, Notification, FormItem,
    Form, Tooltip, DatePicker, Checkbox, Select, Option, Col, Pagination, Row} from 'element-ui'
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  Vue.use(Form)
  Vue.use(Select)
  Vue.use(FormItem)
  export default {
    name: 'StroskovniNosilci',
    components: {
      [Button.name]: Button,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Input.name]: Input,
      [Loading.name]: Loading,
      [MessageBox.name]: MessageBox,
      [Notification.name]: Notification,
      [FormItem.name]: FormItem,
      [Form.name]: Form,
      [Tooltip.name]: Tooltip,
      [DatePicker.name]: DatePicker,
      [Checkbox.name]: Checkbox,
      [Select.name]: Select,
      [Option.name]: Option,
      [Col.name]: Col,
      [Pagination.name]: Pagination,
      [Row.name]: Row
    },
    data () {
      return {
        seznamTelefonskihStroskovniNosilec: [],
        nalaganjeTelefonskihStevilk: true,
        seznamTelefonskihStevilk: [],
        prosteTelefonskeStevilke: [],
        ustvarjeniStroskovniNosilci: [],
        nalaganjeSeznamaStevilkNaNosilcu: true,
        nazivNosilca: '',
        identitetaNosilca: '',
        seznamPodRacunovTelefonskeStevilke: [],
        seznamPodRacunovTelStevilk: [],
        nalaganjeSeznamPodRacunovTelefonskeStevilke: false,
        seznamStevilkNaNosilcu: [],
        nazivStroskovnegaNosilca: '',
        dolzinaSeznama: null,
        disabledGumb: true,
        dolzinaSeznamaNosilci: null,
        seznamStevilkZaDodajanje: [],
        urejanjePodatkov: '0',
        uspesnoDodanNosilec: false,
        idNosilec: '',
        novNazivNosilca: '',
        novaOznakaNosilca: '',
        expandRowKeys: [],
        expandRowMsisdnKeys: [],
        expandRowStevilkaKeys: [],
        urejanjePosamezneTelefonskeNeomejeno: true,
        dodajanjeInUrejanjeTelefonskeStevilke: true,
        onemogocenoSpreminjanjeDatuma: true,
        onemogocenoSpreminjanjeDodajanjeDatuma: true,
        nalaganjeDatumovUrejanjePosameznmaStevilka: true,
        nalaganjeUstvarjenihStroskovnihNosilcev: false,
        posameznaStevilkaTrajanjeOd: '',
        posameznaStevilkaTrajanjeDo: '',
        trajanjeOdDodajanjeStevilk: '',
        trajanjeDoDodajanjeStevilk: '',
        expandedRows: false,
        ustvarjenNosilec: false,
        urejanjeStroskovnegaNosilcaIskanjeTel: '',
        izbranaTelefonskaStevilka: '',
        spremembaTrajanjaOdPosameznaStevilka: '',
        izbranaTelStZaPregled: '',
        niPodatkovOstevilki: '',
        urejanjeZaToStevilko: '',
        nalaganjePodatkovOstevilki: false,
        trenutnoIzbranaStran: 1,
        trenutnoIzbranaStranNosilci: 1,
        spremembaTrajanjaDoPosameznaStevilka: '',
        stevilkeDodaneVnosilec: [],
        pridobivanjePodatkovStevilkeDodaneVnosilec: false,
        dodajanjeStevilk: '',
        pickerOptions: {
          disabledDate (time) {
            const today = new Date()
            today.setHours(0)
            today.setMinutes(0)
            today.setSeconds(0)
            today.setMilliseconds(0)
            return time.getTime() < today
          }
        },
        trenutnoIzbranaStranStroskovniNosilci: 1,
        seznamPodStroskovnihNosilcev: [],
        trenutnoIzbranaStranSeznamTelefonskihStevilk: 1,
        seznamPodTelefonskihStevilk: [],
        dolzinaSeznamaTelefonskihStevilk: null,
        isciPoPodatkih: '',
        filterStevilk: []
      }
    },
    props: {
      izbranSap: '',
      izbranIdStranka: null
    },
    watch: {
      izbranSap: function () {
        if (this.izbranSap !== null) {
          this.OsveziSeznamTelefonskihStevilk()
        }
      },
      izbranIdStranka: function () {
        if (this.izbranSap !== null) {
          this.PridobitevStroskovnihNosilcev()
        }
      },
      urejanjePosamezneTelefonskeNeomejeno: function (val) {
        if (val === true) {
          this.onemogocenoSpreminjanjeDatuma = 'disabled'
        } else {
          this.onemogocenoSpreminjanjeDatuma = false
        }
      },
      dodajanjeInUrejanjeTelefonskeStevilke: function (val) {
        if (val === true) {
          this.onemogocenoSpreminjanjeDodajanjeDatuma = 'disabled'
        } else {
          this.onemogocenoSpreminjanjeDodajanjeDatuma = false
        }
      },
      isciPoPodatkih: function (val) {
        if (val.length > 0) {
          let podatek = this.filterStevilk.filter(x => (typeof x.nosilecNaziv !== 'undefined' && x.nosilecNaziv.toLowerCase().includes(val.toLowerCase())) ||
              (typeof x.stevilka !== 'undefined' && x.stevilka.toString().includes(val)))
          this.seznamPodTelefonskihStevilk = podatek
        } else {
          this.OsveziSeznamTelefonskihStevilk()
        }
      }
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.OsveziSeznamTelefonskihStevilk()
    },
    methods: {
      ResetPodatkov () {
        this.novaOznakaNosilca = ''
        this.novNazivNosilca = ''
        this.seznamStevilkZaDodajanje = []
        this.uspesnoDodanNosilec = false
      },
      Izbranavrstica (row, expandedRows) {
        this.stevilkeDodaneVnosilec = []
        const id = row.id_expense_account
        const lastId = this.expandRowKeys[0]
        this.expandRowKeys = id === lastId ? [] : [id]
        if (expandedRows.length !== 0) {
          this.VseStevilkeKiSoNaNosilcu(row)
        }
        this.urejanjePodatkov = '0'
      },
      IzbranavrsticaVnosilcu (row, expandedRows) {
        this.posameznaStevilkaTrajanjeDo = ''
        const id = row.unicId
        const lastId = this.expandRowMsisdnKeys[0]
        this.expandRowMsisdnKeys = id === lastId ? [] : [id]
        if (expandedRows.length !== 0) {
          this.PridobivanjeStroskovniNosilecGledeNaStevilko(row.msisdn)
        }
      },
      SeznamTelefonskihStevilk (row, expandedRows) {
        const id = row.stevilka
        const lastId = this.expandRowStevilkaKeys[0]
        this.expandRowStevilkaKeys = id === lastId ? [] : [id]
        if (expandedRows.length !== 0) {
          this.PridobivanjeStroskovniNosilecGledeNaStevilko(row.stevilka)
        }
      },
      getTelefonskeAdmin () {
        if (this.izbranSap !== '' && this.izbranSap !== null) {
          let request = {
            permissionId: 'ADMIN_PORABA_TELEFONIJA',
            filter: {
              'sap': this.izbranSap
            }
          }
          return this.clientAgent.makeRequest(
            'permissions/havePermission',
            request,
            'POST'
          )
        }
      },
      async OsveziSeznamTelefonskihStevilk () {
        if (this.izbranSap !== '' && this.izbranSap !== null) {
          this.nalaganjeTelefonskihStevilk = true
          let request = {
            permissionId: 'PORABA_TELEFONIJA',
            filter: {
              'sap': this.izbranSap
            }
          }
          let response = await this.clientAgent.makeRequest(
            'permissions/havePermission',
            request,
            'POST'
          )
          if (response.permission.results === null || response.permission.results.length === 0) {
            response = await this.getTelefonskeAdmin()
          }
          this.SetSeznamTelefonskihStevilk(response)
        }
      },
      SetSeznamTelefonskihStevilk (podatki) {
        this.seznamTelefonskihStevilk = []
        this.prosteTelefonskeStevilke = []
        if (podatki.permission.results.length > 0) {
          this.seznamTelefonskihStroskovniNosilec = podatki.permission.results
          for (let i = 0; i < this.seznamTelefonskihStroskovniNosilec.length; i++) {
            this.seznamTelefonskihStevilk.push({'stevilka': this.seznamTelefonskihStroskovniNosilec[i]})
          }
        }
        this.PridobitevStroskovnihNosilcev()
      },
      PridobitevStroskovnihNosilcev () {
        this.nalaganjeUstvarjenihStroskovnihNosilcev = true
        let param = ['idStranka=' + this.izbranIdStranka]
        this.clientAgent.postWsRequest(this,
          'mercury/nosilci/nosilci?',
          param,
          null,
          'SetPridobitevStroskovnihNosilcev',
          'ErrPridobitevStroskovnihNosilcev')
      },
      SetPridobitevStroskovnihNosilcev (podatki) {
        this.seznamTelefonskihStevilk = this.seznamTelefonskihStevilk.flat()
        this.ustvarjeniStroskovniNosilci = []
        this.seznamStroskovnihNosilcev = podatki.data
        for (let i = 0; i < this.seznamStroskovnihNosilcev.length; i++) {
          this.ustvarjeniStroskovniNosilci.push(this.seznamStroskovnihNosilcev[i])
        }
        if (this.ustvarjenNosilec === true) {
          this.expandRowKeys = [this.ustvarjeniStroskovniNosilci[0].naziv]
        } else {
          this.expandRowKeys = []
        }
        let seznamRelacij = []
        for (let j = 0; j < this.seznamStroskovnihNosilcev.length; j++) {
          let nosilec = this.seznamStroskovnihNosilcev[j]
          for (let k = 0; k < nosilec.relations.length; k++) {
            let relacija = nosilec.relations[k]
            seznamRelacij.push(relacija.msisdn)
            seznamRelacij.push(relacija.trajanje_do)
            for (let i = 0; i < this.seznamTelefonskihStevilk.length; i++) {
              let iskanaTelSt = this.seznamTelefonskihStevilk[i].stevilka + ''
              if (relacija.msisdn + '' === iskanaTelSt && nosilec.naziv.length > 0) {
                this.seznamTelefonskihStevilk[i].nosilecNaziv = nosilec.naziv
                this.seznamTelefonskihStevilk[i].trajanje_do = nosilec.trajanje_do
              }
            }
          }
        }
        this.prosteTelefonskeStevilke = []
        if (this.seznamTelefonskihStevilk.length > 0) {
          for (let i = 0; i < this.seznamTelefonskihStevilk.length; i++) {
            if (this.seznamTelefonskihStevilk[i].nosilecNaziv === undefined) {
              this.prosteTelefonskeStevilke.push(this.seznamTelefonskihStevilk[i])
            }
          }
        }
        this.filterStevilk = this.seznamTelefonskihStevilk
        let seznamZaPegination = []
        this.dolzinaSeznamaTelefonskihStevilk = this.seznamTelefonskihStevilk.length
        const razrez = 8
        for (let i = 0; i < this.dolzinaSeznamaTelefonskihStevilk; i += razrez) {
          seznamZaPegination.push(this.seznamTelefonskihStevilk.slice(i, i + razrez))
        }
        this.seznamTelefonskihStevilk = seznamZaPegination
        this.PrikaziStranSeznamTelefonskihStevilk(1)
        this.nalaganjeUstvarjenihStroskovnihNosilcev = false
        let tmpArray = []
        this.dolzinaSeznamaStroskovnihNosilcev = this.ustvarjeniStroskovniNosilci.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaSeznamaStroskovnihNosilcev; i += chunk) {
          tmpArray.push(this.ustvarjeniStroskovniNosilci.slice(i, i + chunk))
        }
        this.ustvarjeniStroskovniNosilci = tmpArray
        this.PrikaziStranUstvarjenihStroskovnihNosilcev(1)
      },
      PrikaziStranUstvarjenihStroskovnihNosilcev (stran) {
        if (typeof this.ustvarjeniStroskovniNosilci[stran - 1] !== 'undefined') {
          this.seznamPodStroskovnihNosilcev = this.ustvarjeniStroskovniNosilci[stran - 1]
        } else {
          this.seznamPodStroskovnihNosilcev = this.ustvarjeniStroskovniNosilci
        }
      },
      PrikaziStranSeznamTelefonskihStevilk (stran) {
        if (typeof this.seznamTelefonskihStevilk[stran - 1] !== 'undefined') {
          this.seznamPodTelefonskihStevilk = this.seznamTelefonskihStevilk[stran - 1]
        } else {
          this.seznamPodTelefonskihStevilk = []
        }
        this.nalaganjeTelefonskihStevilk = false
      },
      ErrPridobitevStroskovnihNosilcev () {
        this.nalaganjeUstvarjenihStroskovnihNosilcev = false
      },
      OdstranitevStroskovnegaNosilca (idNosilec, naziv) {
        MessageBox.confirm('Ali ste prepričani, da želite odstraniti stroškovni nosilec (' + naziv + ')?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          let param = ['idStranka=' + this.izbranIdStranka]
          param.push('tip=nosilec')
          param.push('idExpenseAccount=' + idNosilec)
          this.clientAgent.postWsRequest(this,
            '/mercury/nosilci/izbrisiNosilec?',
            param,
            null,
            'SetOdstranitevStroskovnegaNosilca',
            'ErrOdstranitevStroskovnegaNosilca')
        }).catch((err) => {
          err = null
        })
      },
      SetOdstranitevStroskovnegaNosilca () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno odstranjen stroškovni nosilec.'
        this.ShowSuccessMessage(paramObvestilo)
        this.OsveziSeznamTelefonskihStevilk()
      },
      ErrOdstranitevStroskovnegaNosilca (podatki) {
        this.ShowWarningMessage(podatki)
      },
      DodajanjeNovegaStroskovnegaNosilca () {
        if (this.novNazivNosilca === '' || this.novaOznakaNosilca === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Naziv ali oznaka stroškovnega nosilca ne sme biti prazen.'
          this.ShowWarningMessage(paramObvestilo)
        } else {
          this.uspesnoDodanNosilec = true
          let param = ['idStranka=' + this.izbranIdStranka]
          param.push('naziv=' + this.novNazivNosilca)
          param.push('identiteta=' + this.novaOznakaNosilca)
          this.clientAgent.postWsRequest(this,
            'mercury/nosilci/shraniNosilec?',
            param,
            null,
            'SetUrejanjeObstojecegaStroskovnegaNosilca',
            'ErrUrejanjeObstojecegaStroskovnegaNosilca')
        }
      },
      SetUrejanjeObstojecegaStroskovnegaNosilca () {
        this.urejanjePodatkov = '1'
        this.ustvarjenNosilec = true
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno ustvarjen nov stroškovni nosilec.'
        this.ShowSuccessMessage(paramObvestilo)
        this.uspesnoDodanNosilec = false
        this.novNazivNosilca = ''
        this.novaOznakaNosilca = ''
        this.PridobitevStroskovnihNosilcev()
      },
      ErrUrejanjeObstojecegaStroskovnegaNosilca (podatki) {
        if (this.novNazivNosilca === '') {
          let paramObvestilo = {}
          paramObvestilo.message = 'Naziv stroškovnega nosilca ne sme biti prazen.'
          this.ShowWarningMessage(paramObvestilo)
        } else {
          let paramObvestilo = {}
          paramObvestilo.message = podatki.message
          this.ShowWarningMessage(paramObvestilo)
        }
        this.uspesnoDodanNosilec = false
      },
      VseStevilkeKiSoNaNosilcu (idNosilec, naziv, identiteta) {
        this.seznamPodRacunovTelefonskeStevilke = []
        this.seznamStevilkNaNosilcu = []
        this.nalaganjeSeznamPodRacunovTelefonskeStevilke = true
        this.identitetaNosilca = identiteta
        this.nazivNosilca = naziv
        this.idNosilec = idNosilec.id_expense_account
        this.nalaganjeSeznamaStevilkNaNosilcu = true
        let param = ['idStranka=' + this.izbranIdStranka]
        if (typeof this.idNosilec === 'undefined') {
          param.push('idExpenseAccount=' + idNosilec)
        } else {
          param.push('idExpenseAccount=' + this.idNosilec)
        }
        this.clientAgent.postWsRequest(this,
          'mercury/nosilci/msisdn?',
          param,
          idNosilec,
          'SetVseStevilkeKiSoNaNosilcu',
          'ErrVseStevilkeKiSoNaNosilcu')
      },
      SetVseStevilkeKiSoNaNosilcu (podatki, idNosilec) {
        this.izbranaTelStZaPregled = ''
        this.seznamStevilkNaNosilcu = podatki.data
        if (this.seznamStevilkNaNosilcu.length > 0) {
          this.RelacijeMedNosilci(idNosilec)
        }
        let tmpArray = []
        this.dolzinaSeznama = this.seznamStevilkNaNosilcu.length
        const chunk = 12
        for (let i = 0; i < this.dolzinaSeznama; i += chunk) {
          tmpArray.push(this.seznamStevilkNaNosilcu.slice(i, i + chunk))
        }
        this.seznamStevilkNaNosilcu = tmpArray
        this.PrikaziStran(1)
        this.nalaganjeSeznamaStevilkNaNosilcu = false
      },
      PrikaziStran (stran) {
        this.trenutnoIzbranaStran = stran
        if (typeof this.seznamStevilkNaNosilcu[this.trenutnoIzbranaStran - 1] !== 'undefined') {
          this.seznamPodRacunovTelefonskeStevilke = this.seznamStevilkNaNosilcu[this.trenutnoIzbranaStran - 1]
          this.izbranaTelStZaPregled = this.seznamPodRacunovTelefonskeStevilke[0].msisdn
        } else {
          this.seznamPodRacunovTelefonskeStevilke = this.seznamStevilkNaNosilcu
        }
        this.nalaganjeSeznamPodRacunovTelefonskeStevilke = false
      },
      BrisanjeStevilkeIzStroskovnegaNosilca (telefonska, idexpenseaccount) {
        MessageBox.confirm('Ali ste prepričani, da želite odstraniti telefonsko številko' +
        ' (' + telefonska + ')?', {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          let param = ['idStranka=' + this.izbranIdStranka]
          param.push('idExpenseAccount=' + idexpenseaccount)
          param.push('msisdn=' + telefonska)
          this.clientAgent.postWsRequest(this,
            'mercury/nosilci/izbrisiStevilko?',
            param,
            null,
            'SetBrisanjeStevilkeIzStroskovnegaNosilca',
            'ErrBrisanjeStevilkeIzStroskovnegaNosilca')
        }).catch((err) => {
          err = null
          this.ErrBrisanjeStevilkeIzStroskovnegaNosilca()
        })
      },
      SetBrisanjeStevilkeIzStroskovnegaNosilca () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno odstranjena telefonska številka.'
        this.ShowSuccessMessage(paramObvestilo)
        this.OsveziSeznamTelefonskihStevilk()
        this.nalaganjeSeznamaStevilkNaNosilcu = false
      },
      ErrBrisanjeStevilkeIzStroskovnegaNosilca (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjeSeznamaStevilkNaNosilcu = false
      },
      DodajanjeStevilkeNaStroskovniNosilec (idExpenseAccount) {
        if (this.spremembaTrajanjaOdPosameznaStevilka !== '') {
          if (this.dodajanjeInUrejanjeTelefonskeStevilke === true) {
            this.trajanjeDoDodajanjeStevilk = 'Neomejeno'
            this.neomejeno = '2300-01-01 00:00:00'
            let param = ['idStranka=' + this.izbranIdStranka]
            param.push('idExpenseAccount=' + idExpenseAccount)
            param.push('msisdn=' + this.dodajanjeStevilk)
            param.push('trajanjeOd=' + encodeURI(this.spremembaTrajanjaOdPosameznaStevilka))
            param.push('trajanjeDo=' + encodeURI(this.neomejeno))
            this.clientAgent.postWsRequest(this,
              'mercury/nosilci/shraniStevilko?',
              param,
              null,
              'SetDodajanjeStevilkeNaStroskovniNosilec',
              'ErrDodajanjeStevilkeNaStroskovniNosilec')
          } else {
            let param = ['idStranka=' + this.izbranIdStranka]
            param.push('idExpenseAccount=' + idExpenseAccount)
            param.push('msisdn=' + this.dodajanjeStevilk)
            param.push('trajanjeOd=' + encodeURI(this.spremembaTrajanjaOdPosameznaStevilka))
            param.push('trajanjeDo=' + encodeURI(this.spremembaTrajanjaDoPosameznaStevilka))
            this.clientAgent.postWsRequest(this,
              'mercury/nosilci/shraniStevilko?',
              param,
              null,
              'SetDodajanjeStevilkeNaStroskovniNosilec',
              'ErrDodajanjeStevilkeNaStroskovniNosilec')
          }
        }
      },
      SetDodajanjeStevilkeNaStroskovniNosilec () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno dodana telefonska številka na nosilec.'
        this.ShowSuccessMessage(paramObvestilo)
        this.expandRowKeys = []
        this.OsveziSeznamTelefonskihStevilk()
        this.ClearAddNumberToExpenseHolder()
      },
      ErrDodajanjeStevilkeNaStroskovniNosilec (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
        this.ClearAddNumberToExpenseHolder()
      },
      UrejanjeStevilkeNaStroskovnemNosilcu () {
        if (this.urejanjePosamezneTelefonskeNeomejeno === true) {
          this.posameznaStevilkaTrajanjeDo = ''
          this.neomejeno = '2300-01-01 00:00:00'
          let param = ['idStranka=' + this.izbranIdStranka]
          param.push('idExpenseAccount=' + this.id)
          param.push('idNumberRelation=' + this.idMsisdn)
          param.push('msisdn=' + this.urejanjeZaToStevilko)
          param.push('trajanjeOd=' + encodeURI(this.posameznaStevilkaTrajanjeOd))
          param.push('trajanjeDo=' + encodeURI(this.neomejeno))
          this.clientAgent.postWsRequest(this,
            'mercury/nosilci/shraniStevilko?',
            param,
            null,
            'SetUrejanjeStevilkeNaStroskovnemNosilcu',
            'ErrUrejanjeStevilkeNaStroskovnemNosilcu')
        } else {
          let param = ['idStranka=' + this.izbranIdStranka]
          param.push('idExpenseAccount=' + this.id)
          param.push('idNumberRelation=' + this.idMsisdn)
          param.push('msisdn=' + this.urejanjeZaToStevilko)
          param.push('trajanjeOd=' + encodeURI(this.posameznaStevilkaTrajanjeOd))
          param.push('trajanjeDo=' + encodeURI(this.posameznaStevilkaTrajanjeDo))
          this.clientAgent.postWsRequest(this,
            'mercury/nosilci/shraniStevilko?',
            param,
            null,
            'SetUrejanjeStevilkeNaStroskovnemNosilcu',
            'ErrUrejanjeStevilkeNaStroskovnemNosilcu')
        }
      },
      SetUrejanjeStevilkeNaStroskovnemNosilcu () {
        let paramObvestilo = {}
        paramObvestilo.message = 'Uspešno posodobljena telefonska številka.'
        this.ShowSuccessMessage(paramObvestilo)
        this.OsveziSeznamTelefonskihStevilk()
      },
      ErrUrejanjeStevilkeNaStroskovnemNosilcu (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
      },
      PridobivanjeStroskovniNosilecGledeNaStevilko (stevilka) {
        this.nalaganjePodatkovOstevilki = true
        this.nalaganjeDatumovUrejanjePosameznmaStevilka = true
        let param = ['idStranka=' + this.izbranIdStranka]
        param.push('msisdn=' + stevilka)
        this.clientAgent.postWsRequest(this,
          'mercury/nosilci/msisdn?',
          param,
          null,
          'SetPridobivanjeStroskovniNosilecGledeNaStevilko',
          'ErrPridobivanjeStroskovniNosilecGledeNaStevilko')
      },
      SetPridobivanjeStroskovniNosilecGledeNaStevilko (podatki) {
        this.urejanjeZaToStevilko = ''
        this.niPodatkovOstevilki = podatki.data
        if (podatki.data.length > 0 && typeof podatki.data[0].msisdn !== 'undefined') {
          this.urejanjeZaToStevilko = podatki.data[0].msisdn
          this.id = podatki.data[0].id_expense_account
          this.idMsisdn = podatki.data[0].id_expense_account_msisdn
        }
        this.nazivStroskovnegaNosilca = ''
        if (podatki.data.length > 0) {
          for (let i = 0; i < podatki.data.length; i++) {
            this.nazivStroskovnegaNosilca = podatki.data[i].naziv
            this.id = podatki.data[i].id_expense_account
            this.idMsisdn = podatki.data[i].id_expense_account_msisdn
            if (podatki.data[i].trajanje_do === '01.01.2300') {
              this.onemogocenoSpreminjanjeDatuma = 'disabled'
              this.onemogocenoSpreminjanjeDodajanjeDatuma = 'disabled'
            } else {
              this.urejanjePosamezneTelefonskeNeomejeno = false
              let formatDatuma = podatki.data[i].trajanje_do
              let formatDatumaArr = formatDatuma.split('.')
              formatDatuma = formatDatumaArr[2] + '-' + formatDatumaArr[1] + '-' + formatDatumaArr[0] + ' 00:00:00'
              this.posameznaStevilkaTrajanjeDo = formatDatuma
            }
            let formatDatuma1 = podatki.data[i].trajanje_od
            let formatDatumaArr1 = formatDatuma1.split('.')
            formatDatuma1 = formatDatumaArr1[2] + '-' + formatDatumaArr1[1] + '-' + formatDatumaArr1[0] + ' 00:00:00'
            this.posameznaStevilkaTrajanjeOd = formatDatuma1
          }
        }
        this.nalaganjePodatkovOstevilki = false
      },
      ErrPridobivanjeStroskovniNosilecGledeNaStevilko (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
        this.nalaganjePodatkovOstevilki = false
      },
      RelacijeMedNosilci (idNosilec) {
        this.pridobivanjePodatkovStevilkeDodaneVnosilec = true
        let param = ['idStranka=' + this.izbranIdStranka]
        if (typeof this.idNosilec === 'undefined') {
          param.push('idExpenseAccount=' + idNosilec)
        } else {
          param.push('idExpenseAccount=' + this.idNosilec)
        }
        this.clientAgent.postWsRequest(this,
          'mercury/nosilci/relacije?',
          param,
          null,
          'SetRelacijeMedNosilci',
          'ErrRelacijeMedNosilci')
      },
      SetRelacijeMedNosilci (podatki) {
        this.stevilkeDodaneVnosilec = []
        for (let i = 0; i < podatki.data.length; i++) {
          Vue.set(podatki.data[i], 'unicId', i)
        }
        this.stevilkeDodaneVnosilec = podatki.data
        let tmpArray = []
        this.dolzinaSeznamaNosilci = this.stevilkeDodaneVnosilec.length
        const chunk = 4
        for (let i = 0; i < this.dolzinaSeznamaNosilci; i += chunk) {
          tmpArray.push(this.stevilkeDodaneVnosilec.slice(i, i + chunk))
        }
        this.stevilkeDodaneVnosilec = tmpArray
        this.PrikaziStranDodaneStevilkeVnosilec(1)
      },
      PrikaziStranDodaneStevilkeVnosilec (stran) {
        this.trenutnoIzbranaStranNosilci = stran
        if (typeof this.stevilkeDodaneVnosilec[this.trenutnoIzbranaStranNosilci - 1] !== 'undefined') {
          this.seznamPodRacunovTelStevilk = this.stevilkeDodaneVnosilec[this.trenutnoIzbranaStranNosilci - 1]
        } else {
          this.seznamPodRacunovTelStevilk = this.stevilkeDodaneVnosilec
        }
        this.pridobivanjePodatkovStevilkeDodaneVnosilec = false
      },
      ErrRelacijeMedNosilci (podatki) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
        this.pridobivanjePodatkovStevilkeDodaneVnosilec = false
      },
      ClearAddNumberToExpenseHolder () {
        this.dodajanjeStevilk = ''
        this.spremembaTrajanjaOdPosameznaStevilka = ''
        this.spremembaTrajanjaDoPosameznaStevilka = ''
      }
    }
  }
</script>
<style scoped src="../../../../../../static/css/MojT-2/Racuni/StroskovniNosilci.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni/StroskovniNosilci.vue